import { render, staticRenderFns } from "./ScriptArgInput.vue?vue&type=template&id=642c2fd4"
import script from "./ScriptArgInput.vue?vue&type=script&lang=ts"
export * from "./ScriptArgInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642c2fd4')) {
      api.createRecord('642c2fd4', component.options)
    } else {
      api.reload('642c2fd4', component.options)
    }
    module.hot.accept("./ScriptArgInput.vue?vue&type=template&id=642c2fd4", function () {
      api.rerender('642c2fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scripts/ScriptArgInput.vue"
export default component.exports